"use strict";
// _top-lifeInHokkaido.js — コラージュ写真のランダム順フェードイン（監視は observer.js の data-observer-once）

(() => {
  const initLifeInHokkaido = () => {
    const collage = document.querySelector(".p-top-lifeInHokkaido__collage[data-observer-once]");
    if (!collage) {
      return;
    }

    const photos = collage.querySelectorAll(".p-top-lifeInHokkaido__photo");
    if (!photos.length) {
      return;
    }

    const INTERVAL = 500;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const shuffle = (items) => {
      const arr = Array.from(items);

      for (let i = arr.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }

      return arr;
    };

    const reset = () => {
      photos.forEach((photo) => {
        photo.style.transition = "none";
        photo.style.transitionDelay = "";
        photo.classList.remove("is-visible");
      });

      void collage.offsetHeight;

      photos.forEach((photo) => {
        photo.style.transition = "";
      });
    };

    const showAll = () => {
      photos.forEach((photo) => {
        photo.style.transitionDelay = "";
        photo.classList.add("is-visible");
      });
    };

    const play = () => {
      reset();

      if (reduceMotion.matches) {
        showAll();
        return;
      }

      shuffle(photos).forEach((photo, index) => {
        photo.style.transitionDelay = `${index * INTERVAL}ms`;
        photo.classList.add("is-visible");
      });
    };

    const bind = () => {
      collage.addEventListener("observer:enter", play, { once: true });
    };

    if (!("IntersectionObserver" in window)) {
      play();
      return;
    }

    reset();
    bind();

    window.addEventListener("pageshow", (event) => {
      if (!event.persisted) {
        return;
      }

      reset();
      bind();
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLifeInHokkaido, { once: true });
  } else {
    initLifeInHokkaido();
  }
})();
